"use client";
import { useToken } from "./auth";
import { fetchWithNoResponse, baseBFF, fetcher } from "./_utils";
import useSWRMutation from "swr/mutation";
import { CustomerModel } from "@/types/User";

export const useDelete = (): {
  trigger: (args: any) => any;
} => {
  const token = useToken();
  const { trigger } = useSWRMutation(
    token ? [`/${baseBFF()}/menu/close-account`, token] : null,
    ([url, token], { arg }) => fetchWithNoResponse(url, token, "DELETE", arg),
  );
  return {
    trigger: trigger,
  };
};

export const useFetchUserDetails = (): {
  trigger: () => any;
  isFetchingUserDetailsLoading: boolean;
  isFetchingUserDetailsError: boolean;
  userDetails: CustomerModel;
} => {
  const token = useToken();

  const { trigger, isMutating, error, data } = useSWRMutation(
    token ? [`/${baseBFF()}/customer/cc-details`, token] : null,
    ([url, token]: [url: string, token: string]) => fetcher(url, token),
  );

  return {
    trigger: trigger,
    isFetchingUserDetailsLoading: isMutating,
    isFetchingUserDetailsError: error,
    userDetails: data,
  };
};

export const useSendSuperProperties = (
  token?: string,
): {
  trigger: (args: { properties: { key: string; value: string }[] }) => any;
  sendingSuperPropertiesLoading: boolean;
  sendSuperPropertiesError: boolean;
} => {
  const { trigger, isMutating, error } = useSWRMutation(
    token ? [`/${baseBFF()}/super-property`, token] : null,
    (
      [url, token]: [url: string, token: string],
      { arg }: { arg: { properties: { key: string; value: string }[] } },
    ) => fetcher(url, token, "POST", arg),
  );

  return {
    trigger: trigger,
    sendingSuperPropertiesLoading: isMutating,
    sendSuperPropertiesError: !!error,
  };
};
